import type { DeviceStatusSubscriptionAPI } from './Definitions';
import { toDeviceStatusSubscription, toDeviceStatusSubscriptionAPI } from './DeviceStatusSubscriptionTransformer';
import { gql } from '@apollo/client';

import type { DeviceStatusSubscription, UUID } from '@cobliteam/common-types';

import graphQLRequester from '../../../request/GraphQLRequester';

export class GraphQLDeviceStatusSubscriptionRequester {
  public getSubscription = (): Promise<DeviceStatusSubscription> =>
    graphQLRequester
      .query<{ deviceStatusSubscription: DeviceStatusSubscriptionAPI }>({
        query: gql`
          query deviceStatusSubscription {
            deviceStatusSubscription {
              id
              active
              vehicle_ids
              vehicle_group_ids
            }
          }
        `,
      })
      .then((result) => toDeviceStatusSubscription(result.deviceStatusSubscription));

  public updateSubscription = (deviceStatusSubscription: DeviceStatusSubscription): Promise<UUID> =>
    graphQLRequester
      .mutate<{ updateDeviceStatusSubscription: UUID }>({
        mutation: gql`
          mutation UpdateDeviceStatusSubscription(
            $subscriptionToUpdate: DeviceStatusSubscriptionInput
          ) {
            updateDeviceStatusSubscription(input: $subscriptionToUpdate)
          }
        `,
        variables: {
          subscriptionToUpdate: toDeviceStatusSubscriptionAPI(deviceStatusSubscription),
        },
      })
      .then((graphQlResponse) => graphQlResponse.updateDeviceStatusSubscription);
}

export default GraphQLDeviceStatusSubscriptionRequester;
